import { useContext } from 'react';
import SessionContext from '#/app/providers/SessionProvider/SessionContext';

export const useSession = () => {
  const session = useContext(SessionContext);

  return session;
};

export default useSession;
